"use strict";
/// see https://gist.github.com/mudge/5830382
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = void 0;
/* Polyfill indexOf. */
var indexOf;
if (typeof Array.prototype.indexOf === "function") {
    indexOf = function (haystack, needle) { return haystack.indexOf(needle); };
}
else {
    indexOf = function (haystack, needle) {
        var length = haystack.length;
        var i = 0;
        var idx = -1;
        var found = false;
        while (i < length && !found) {
            if (haystack[i] === needle) {
                idx = i;
                found = true;
            }
            i++;
        }
        return idx;
    };
}
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.events = {};
    }
    EventEmitter.prototype.on = function (event, listener) {
        if (typeof this.events[event] !== "object") {
            this.events[event] = [];
        }
        this.events[event].push(listener);
    };
    EventEmitter.prototype.off = function (event, listener) {
        var idx;
        if (typeof this.events[event] === "object") {
            idx = indexOf(this.events[event], listener);
            if (idx > -1) {
                this.events[event].splice(idx, 1);
            }
        }
    };
    EventEmitter.prototype.emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var i;
        var listeners;
        var length;
        if (typeof this.events[event] === "object") {
            listeners = this.events[event].slice();
            length = listeners.length;
            for (i = 0; i < length; i++) {
                listeners[i].apply(this, args);
            }
        }
    };
    EventEmitter.prototype.once = function (event, listener) {
        var that = this;
        // tslint:disable-next-line:only-arrow-functions
        this.on(event, function g() {
            that.off(event, g);
            listener.apply(that, arguments);
        });
    };
    return EventEmitter;
}());
exports.EventEmitter = EventEmitter;
//# sourceMappingURL=event-emitter.js.map